<template>
    <div class="inner-container h-100">
        <!--     фильтры/кнопки     -->
        <div class="filter-container">
            <b-dropdown class="filter-dropdown" variant="default" ref="drop">
                <template #button-content>
                    <span class="lc"><i class="icon icon-filter"></i>{{ trMsg(MSG_BIP + 'filter.title') }}</span>
                    <span class="rc"><i class="icon icon-keyboard"></i></span>
                </template>
                <div>
                    <div class="top-content">
                        <span>{{ trMsg(MSG_FILTER + 'title') }}</span>
                        <i
                            class="icon icon-close"
                            @click="$refs.drop.hide(true)"
                        ></i>
                    </div>
                    <!---------- Плановый период ---------------->
                    <div class="filter-block">
                        <b-form-group :label="trMsg(MSG_FILTER + 'plan_period')">
                            <multiselect
                                ref="bcPlanYear"
                                v-model="planPeriod"
                                track-by="name"
                                label="name"
                                :options="yearsFilter"
                                :searchable="false"
                                :allow-empty="false"
                                :show-labels="false">
                            </multiselect>
                        </b-form-group>
                    </div>
                    <!---------- Область/район бюджета ---------->
                    <div class="filter-block">
                        <b-form-group :label="trMsg(MSG_FILTER + 'region_budget')">
                            <multiselect
                                ref="bcRegionBudget"
                                v-model="selRegionBudget"
                                track-by="text"
                                label="text"
                                :options="regionBudgetList"
                                :searchable="true"
                                :allow-empty="false"
                                :show-labels="false">
                            </multiselect>
                        </b-form-group>
                    </div>
                    <!---------- Вид данных --------------------->
                    <div class="filter-block">
                        <b-form-group :label="trMsg(MSG_FILTER + 'data_type')">
                            <multiselect
                                ref="bcDataType"
                                v-model="selDataType"
                                track-by="name"
                                label="name"
                                :options="dataTypeList"
                                :searchable="true"
                                :allow-empty="false"
                                :show-labels="false">
                            </multiselect>
                        </b-form-group>
                    </div>
                    <!---------- Версия бюджета ----------------->
                    <div class="filter-block">
                        <b-form-group :label="trMsg(MSG_FILTER + 'version')">
                            <multiselect
                                ref="bcVersion"
                                v-model="selVersion"
                                track-by="text"
                                label="text"
                                :options="versionFilter"
                                :searchable="true"
                                :allow-empty="false"
                                :show-labels="false">
                            </multiselect>
                        </b-form-group>
                    </div>
                    <!---------- Код ИНГИП ---------------------->
                    <div class="filter-block">
                        <b-form-group :label="trMsg(MSG_FIELD + 'gip_code')">
                            <multiselect
                                ref="bcGip"
                                v-model="selGip"
                                track-by="text"
                                label="text"
                                :options="filterGip"
                                :multiple="true"
                                :searchable="true"
                                :close-on-select="false"
                                :clear-on-select="false"
                                :preserve-search="true">
                                <template v-slot:selection="{ values, search, isOpen }">
                                    <template v-if="!isOpen">
                                        <template v-if="values.length > 1">
                                                    <span class="multiselect__single" id="multiselect__single">
                                                        {{ values.length + ' ' + trMsg(MSG_CARD_SEC + '1.seleсted_projects') }}
                                                    </span>
                                            <b-tooltip target="multiselect__single" placement="right">
                                                <p style="margin-bottom: 0" v-for="program in values" :key="program.code">
                                                    {{ program.name }}
                                                </p>
                                            </b-tooltip>
                                        </template>
                                        <template v-else-if="values.length === 1 && values[0]">
                                                    <span class="multiselect__single">
                                                        {{ values[0].text }}
                                                    </span>
                                        </template>
                                    </template>
                                </template>
                            </multiselect>
                            <b-form-checkbox id="gipFilter" switch
                                             v-model="gipFilter">
                            </b-form-checkbox>
                        </b-form-group>
                    </div>
                    <!---------- Месторасположение проекта ------>
                    <div class="filter-block">
                        <b-form-group :label="trMsg(MSG_FILTER + 'location')">
                            <multiselect
                                ref="bcRegion"
                                v-model="selRegion"
                                track-by="name"
                                label="name"
                                :placeholder="trMsg(MSG_FILTER + 'all')"
                                :options="regionFilter"
                                :searchable="true"
                                :show-labels="false"
                                @input="changeRegion">
                            </multiselect>
                        </b-form-group>
                    </div>
                    <!---------- Направление -------------------->
                    <div class="filter-block">
                        <b-form-group :label="trMsg(MSG_FILTER + 'direction')">
                            <multiselect
                                ref="bcDirection"
                                v-if="directionFilter"
                                v-model="selDirection"
                                track-by="name"
                                label="name"
                                :placeholder="trMsg(MSG_FILTER + 'all')"
                                :options="directionFilter"
                                :searchable="true"
                                :show-labels="false">
                            </multiselect>
                        </b-form-group>
                    </div>
                    <!---------- Тип объекта -------------------->
                    <div class="filter-block">
                        <b-form-group :label="trMsg(MSG_FILTER + 'object_type')">
                            <multiselect
                                ref="bcObject"
                                v-if="objectFilter"
                                v-model="selObject"
                                track-by="name"
                                label="name"
                                :placeholder="trMsg(MSG_FILTER + 'all')"
                                :options="objectFilter"
                                :searchable="true"
                                :show-labels="false">
                            </multiselect>
                        </b-form-group>
                    </div>
                    <!---------- Статус ------------------------->
                    <div class="filter-block">
                        <b-form-group :label="trMsg(MSG_FILTER + 'status')">
                            <multiselect
                                ref="bcStatus"
                                v-if="statusFilter"
                                v-model="selStatus"
                                track-by="name"
                                label="name"
                                :placeholder="trMsg(MSG_FILTER + 'all')"
                                :options="statusFilter"
                                :searchable="true"
                                :show-labels="false">
                            </multiselect>
                        </b-form-group>
                    </div>
                    <!---------- АБП ---------------------------->
                    <div class="filter-block">
                        <b-form-group :label="trMsg(MSG_FILTER + 'ABP')">
                            <multiselect
                                ref="bcAbp"
                                v-model="selAbp"
                                track-by="text"
                                label="text"
                                :placeholder="trMsg(MSG_FILTER + 'all')"
                                :options="abpFilter"
                                :searchable="true"
                                :show-labels="false">
                            </multiselect>
                        </b-form-group>
                    </div>
                    <!---------- ПРГ ---------------------------->
                    <div class="filter-block">
                        <b-form-group :label="trMsg(MSG_FIELD + 'prg')">
                            <multiselect
                                ref="bcPrg"
                                v-model="selPrg"
                                track-by="text"
                                label="text"
                                :placeholder="trMsg(MSG_FILTER + 'all')"
                                :options="prgFilter"
                                :searchable="true"
                                :show-labels="false">
                            </multiselect>
                        </b-form-group>
                    </div>
                    <!---------- ППР ---------------------------->
                    <div class="filter-block">
                        <b-form-group :label="trMsg(MSG_FIELD + 'ppr')">
                            <multiselect
                                ref="bcPpr"
                                v-model="selPpr"
                                track-by="text"
                                label="text"
                                :placeholder="trMsg(MSG_FILTER + 'all')"
                                :options="pprFilter"
                                :searchable="true"
                                :show-labels="false">
                            </multiselect>
                        </b-form-group>
                    </div>
                    <!---------- Гос.программа ------------------>
                    <div class="filter-block">
                        <b-form-group :label="trMsg(MSG_FILTER + 'gov_program')">
                            <multiselect id="idGpList"
                                ref="bcGp"
                                v-model="selGp"
                                track-by="name"
                                label="name"
                                :placeholder="trMsg(MSG_FILTER + 'all')"
                                :options="gpFilter"
                                :searchable="true"
                                :show-labels="false">
                            </multiselect>
                        </b-form-group>
                    </div>
                    <!---------- Характер расходов -------------->
                    <div class="filter-block">
                        <b-form-group :label="trMsg(MSG_FILTER + 'expenses_type')">
                            <multiselect id="idExpTypes"
                                ref="bcRadio"
                                v-model="radio"
                                track-by="name"
                                label="name"
                                :placeholder="trMsg(MSG_FILTER + 'all')"
                                :options="expTypes"
                                :searchable="true"
                                :show-labels="false">
                            </multiselect>
                        </b-form-group>
                    </div>
                </div>
            </b-dropdown>
            <div class="filter-actions" v-if="access">
                <b-button variant="primary"
                          v-if="gip_check"
                          @click="modalGip">{{ trMsg(MSG_BIP + 'btn.send') }}
                </b-button>
                <b-button variant="success"
                          v-if="sign && (sign.status !== 1) && sign.agree && sign.sign"
                          @click="logEDS('sign')">{{ trMsg(MSG_CDF + 'btn.sign_EDS') }}
                </b-button>
                <b-button variant="danger"
                          v-if="sign && (sign.status > 0) && sign.recall"
                          @click="logEDS('revoke')">{{ trMsg(MSG_CDF + 'btn.revoke_EDS') }}
                </b-button>
                <b-button variant="warning"
                          v-if="(selAbp !== null) && sign"
                          @click="logEDS('log')">{{ trMsg(MSG_CDF + 'btn.journal_EDS') }}
                </b-button>
                <b-button variant="success"
                          v-if="mode_opers.length > 0"
                          @click="agreementEvent">
                    {{ trMsg(MSG_BIP + 'btn.actions') }}
                </b-button>
                <b-button variant="success"
                          @click="saveCosts(showBipList.filter((row) => row.addDatas.edited))">
                    {{ trMsg(MSG_BIP + 'btn.save') }}
                </b-button>
            </div>
        </div>

        <!--     Список проектов     -->
        <div v-show="!showForm" class="h-100">
            <!--        хлебные крошки-->
            <div class="filter-breadcrumb">
                <span class="item-breadcrumb"
                      v-if="!openFilterWindow && planPeriod"
                      @click="openFilterByRef('bcPlanYear')">
                    {{ planPeriod.name }}
                </span>
                <span class="item-breadcrumb"
                      v-if="!openFilterWindow && selRegionBudget"
                      @click="openFilterByRef('bcRegionBudget')">
                    {{ selRegionBudget.name }}
                </span>
                <span class="item-breadcrumb"
                      v-if="!openFilterWindow && selDataType"
                      @click="openFilterByRef('bcDataType')">
                    {{ selDataType.name }}
                </span>
                <span class="item-breadcrumb"
                      v-if="!openFilterWindow && selVersion"
                      @click="openFilterByRef('bcVersion')">
                    {{ selVersion.name }}
                </span>
                <span class="item-breadcrumb"
                      v-if="!openFilterWindow && selRegion"
                      @click="openFilterByRef('bcRegion')">
                    {{ selRegion.name }}
                </span>
                <span class="item-breadcrumb"
                      v-if="!openFilterWindow && selDirection"
                      @click="openFilterByRef('bcDirection')">
                    {{ selDirection.name }}
                </span>
                <span class="item-breadcrumb"
                      v-if="!openFilterWindow && selObject"
                      @click="openFilterByRef('bcObject')">
                    {{ selObject.name }}
                </span>
                <span class="item-breadcrumb"
                      v-if="!openFilterWindow && selStatus"
                      @click="openFilterByRef('bcStatus')">
                    {{ selStatus.name }}
                </span>
                <span class="item-breadcrumb"
                      v-if="!openFilterWindow && selAbp"
                      @click="openFilterByRef('bcAbp')">
                    {{ selAbp.abp + '-' + trMsg(MSG_FILTER + 'ABP') }}
                </span>
                <span class="item-breadcrumb"
                      v-if="!openFilterWindow && selPrg"
                      @click="openFilterByRef('bcPrg')">
                    {{ padLeadingZeros(selPrg.prg, 2) }}-БП>
                </span>
                <span class="item-breadcrumb"
                      v-if="!openFilterWindow && selPpr"
                      @click="openFilterByRef('bcPpr')">
                    {{ selPpr.ppr }}-БПП
                </span>
                <span class="item-breadcrumb"
                      v-if="!openFilterWindow && selGp"
                      @click="openFilterByRef('bcGp')">
                    {{ selGp.name }}
                </span>
                <span class="item-breadcrumb"
                      v-if="!openFilterWindow && radio"
                      @click="openFilterByRef('bcRadio')">
                    {{ radio.text }}
                </span>
            </div>
            <b-progress
                variant="success"
                v-show="pBar < 100"
                height="10px"
                :value="pBar"
                striped
                animated
            ></b-progress>
            <div class="table-container">
                <template v-if="showBipList.length > 0">
                    <b-table ref="bipList"
                             :fields="tableFields"
                             :items="showBipList"
                             :striped="true"
                             responsive="true"
                             bordered
                             head-variant="light"
                             sticky-header="true"
                             no-border-collapse>
                        <template #head(check)="scope">
                            <b-form-checkbox v-model="check"
                                             v-if="access && mode_opers.length > 0">
                            </b-form-checkbox>
                        </template>
                        <template #head(support)="scope">
                            <div class="green">{{ scope.label }}</div>
                        </template>
                        <template #head(not_support)="scope">
                            <div class="red">{{ scope.label }}</div>
                        </template>
                        <template #head(plan1)="scope">
                            <div> {{ trMsg(MSG_FIELD + 'including') + parseInt(planPeriod.year)
                            + trMsg(MSG_CARD_SEC + '1.year').toLowerCase() + ', ' +  trMsg(MSG_CARD_SEC + '1.thousand_tg') }}
                            </div>
                        </template>
                        <template #head(plan2)="scope">
                            <div>
                                {{ trMsg(MSG_FIELD + 'including') + (parseInt(planPeriod.year) + 1)
                            + trMsg(MSG_CARD_SEC + '1.year').toLowerCase() + ', ' +  trMsg(MSG_CARD_SEC + '1.thousand_tg') }}
                            </div>
                        </template>
                        <template #head(plan3)="scope">
                            <div>
                                {{ trMsg(MSG_FIELD + 'including') + (parseInt(planPeriod.year) + 2)
                            + trMsg(MSG_CARD_SEC + '1.year').toLowerCase() + ', ' +  trMsg(MSG_CARD_SEC + '1.thousand_tg') }}
                            </div>
                        </template>

                        <template #cell(check)="data">
                            <template v-if="access &&
                                    mode_opers.length > 0 &&
                                    checkAccess(data.item)">
                                <b-form-checkbox v-model="data.item.check">
                                </b-form-checkbox>
                            </template>
                        </template>
                        <template #cell(gipCode)="data">
                            <div class="small-text bold">{{ data.value }}</div>
                        </template>
                        <template #cell(code)="data">
                            <div class="small-text bold">{{ data.value }}</div>
                        </template>
                        <template #cell(name)="data">
                            <div class="text-left">
                                <a href="#" @click="openBip(data.item)">{{ data.item.name }}</a>
                            </div>
                            <!--                    :href="data.item.addDatas.link" target="_blank"-->
                        </template>
                        <template #cell()="data">
                            <div class="text-right">
                                {{ $n(Number(data.value)) }}
                            </div>
                        </template>
                        <template #cell(status)="data">
                            {{ data.item.addDatas.status
                                    ? data.item.addDatas.status.name
                                    : findItem(1, "code", statusList).name }}
                        </template>
                        <template #cell(sign_status)="data">
                            <template v-if="sign">
                                <a href="#" v-if="sign.status === 0" class="text-bold text-center text-danger" @click="openSign">{{ trMsg(MSG_CDF + 'not_signed') }}</a>
                                <a href="#" v-if="sign.status === 2" class="text-bold text-center text-warning" @click="openSign">{{ trMsg(MSG_CDF + 'part_signed') }}</a>
                                <a href="#" v-if="sign.status === 1" class="text-bold text-center text-success" @click="openSign">{{ trMsg(MSG_CDF + 'signed') }}</a>
                            </template>
                        </template>
                        <template #cell(abp)="data">
                            <div>{{ data.item.addDatas.abp.text }}</div>
                        </template>
                        <template #cell(prg)="data">
                            <div
                                class="in-table-grid-item-text"
                                v-for="(fin, index) in data.item.addDatas['finace']"
                                :key="'prg_' + index + data.item.id + fin.prg + fin.spf">
                                {{ padLeadingZeros(fin.prg, 3) }}
                            </div>
                        </template>
                        <template #cell(ppr)="data">
                            <div
                                class="in-table-grid-item-text"
                                v-for="(fin, index) in data.item.addDatas[
                                    'finace'
                                ]"
                                :key="
                                    'ppr_' +
                                    index +
                                    data.item.id +
                                    fin.ppr +
                                    fin.spf
                                "
                            >
                                {{
                                    fin.ppr === null
                                        ? "_"
                                        : padLeadingZeros(fin.ppr, 3)
                                }}
                            </div>
                        </template>
                        <template #cell(ppr_cost)="data">
                            <div
                                class="in-table-grid-item-text"
                                v-for="(fin, index) in data.item.addDatas['finace']"
                                :key="'cost_' + index + data.item.id + fin.ppr + fin.spf">
                                {{ $n(Number(fin["ppr_cost"])) }}
                            </div>
                        </template>
                        <template #cell(plan1)="data">
                            <div class="in-table-grid-item-input">
                                <div class="text">
                                    <span
                                        v-for="(fin, index) in data.item
                                            .addDatas['finace']"
                                        :key="
                                            'div_' +
                                            index +
                                            data.item.id +
                                            fin.ppr +
                                            fin.spf
                                        "
                                    >
                                        {{ $n(fin["fact1"]) }}
                                    </span>
                                </div>
                                <div class="inputs">
                                    <b-form-input
                                        v-for="(fin, ind) in data.item.addDatas['finace']"
                                        :key="ind + 'inp_' + ind + data.item.id + fin.prg + fin.ppr + fin.spf"
                                        :disabled="!access || !isNextStep(data.item) || data.item.sign"
                                        :value="$n(Number(fin.plan1))"
                                        @change="(v) => (fin.plan1 = v)"
                                        @keyup.enter.exact="keyup13"
                                        @keypress="keyPress($event,'^\\d*\\.?\\d{0,9}$')"
                                        @blur="inputFixed(data.item, fin, 'plan1', fin.plan1)">
                                    </b-form-input>
                                </div>
                            </div>
                        </template>
                        <template #cell(plan2)="data">
                            <div class="in-table-grid-item-input">
                                <div class="text">
                                    <span
                                        v-for="(fin, index) in data.item
                                            .addDatas['finace']"
                                        :key="
                                            'div2_' +
                                            index +
                                            data.item.id +
                                            fin.ppr +
                                            fin.spf
                                        "
                                    >
                                        {{ $n(fin["fact2"]) }}
                                    </span>
                                </div>
                                <div class="inputs">
                                    <b-form-input
                                        v-for="(fin, ind) in data.item.addDatas['finace']"
                                        :key="'inp2_' + ind + data.item.id + fin.prg + fin.ppr + fin.spf"
                                        :disabled="!access || !isNextStep(data.item) || data.item.sign"
                                        :value="$n(Number(fin.plan2))"
                                        @change="(v) => (fin.plan2 = v)"
                                        @keyup.enter.exact="keyup13"
                                        @keypress="keyPress($event,'^\\d*\\.?\\d{0,9}$')"
                                        @blur="inputFixed(data.item, fin, 'plan2', fin.plan2)">
                                    </b-form-input>
                                </div>
                            </div>
                        </template>
                        <template #cell(plan3)="data">
                            <div class="in-table-grid-item-input">
                                <div class="text">
                                    <span
                                        v-for="(fin, index) in data.item
                                            .addDatas['finace']"
                                        :key="
                                            'div3_' +
                                            index +
                                            data.item.id +
                                            fin.ppr +
                                            fin.spf
                                        "
                                    >
                                        {{ $n(fin["fact3"]) }}
                                    </span>
                                </div>
                                <div class="inputs">
                                    <b-form-input
                                        v-for="(fin, ind) in data.item.addDatas['finace']"
                                        :key="'inp3_' + ind + data.item.id + fin.prg + fin.ppr + fin.spf"
                                        :disabled="!access || !isNextStep(data.item) || data.item.sign"
                                        :value="$n(Number(fin.plan3))"
                                        @change="(v) => (fin.plan3 = v)"
                                        @keyup.enter.exact="keyup13"
                                        @keypress="keyPress($event, '^\\d*\\.?\\d{0,9}$')"
                                        @blur="inputFixed(data.item, fin, 'plan3', fin.plan3)">
                                    </b-form-input>
                                </div>
                            </div>
                        </template>
                        <template #cell(total)="data">
                            <div
                                class="text-bold text-center"
                                style="font-size: 1.1rem"
                                :class="{
                                    'text-danger': parseFloat(data.value) < 4,
                                    'text-warning':
                                        parseFloat(data.value) >= 4 &&
                                        parseFloat(data.value) < 7,
                                    'text-success': parseFloat(data.value) >= 7,
                                }"
                            >
                                {{ data.value }}
                            </div>
                        </template>
                        <template #cell(more)="data">
                            <b-dropdown dropleft class="more">
                                <template v-slot:button-content>
                                    <i class="icon icon-more"></i>
                                </template>
                                <b-dropdown-item v-if="data.item.addDatas.status"
                                    @click="commentClk(data.item.addDatas.status)">
                                    {{ trMsg(MSG_CARD_SEC + '5.title') }}
                                </b-dropdown-item>
                            </b-dropdown>
                        </template>
                        <template #bottom-row="">
                            <td colspan="2"></td>
                            <td>
                                <div class="text-bold">
                                    {{ showBipList.length }}
                                </div>
                            </td>
                            <td colspan="2">
                                <div class="text-right text-bold">
                                    {{ trMsg(MSG_FIELD + 'total').toUpperCase() + ', ' + trMsg(MSG_CARD_SEC + '1.thousand_tg').toUpperCase() }}
                                </div>
                            </td>
                            <td>
                                <div class="text-right text-bold">
                                    {{ $n(total("totalCost")) }}
                                </div>
                            </td>
                            <td :colspan="(selAbp !== null) ? 5 : 4"></td>
                            <td>
                                <div class="text-right text-bold">
                                    {{ $n(totalFinans) }}
                                </div>
                            </td>
                            <td>
                                <div class="text-right text-bold">
                                    {{ $n(_totalFinans("plan1")) }}
                                </div>
                            </td>
                            <td>
                                <div class="text-right text-bold">
                                    {{ $n(_totalFinans("plan2")) }}
                                </div>
                            </td>
                            <td>
                                <div class="text-right text-bold">
                                    {{ $n(_totalFinans("plan3")) }}
                                </div>
                            </td>
                            <td></td>
                        </template>
                    </b-table>
                </template>
            </div>
        </div>

        <!--     Форма БИПа     -->
        <div v-show="showForm">
            <!--     кнопки     -->
            <div class="filter-container">
                <div class="left-content"></div>
                <div class="right-content">
                    <div class="filter-actions">
                        <b-button class="ml-auto"
                                  variant="light"
                                  @click="showForm = !showForm">
                            {{ trMsg(MSG_BIP + 'btn.back_list') }}
                        </b-button>
                    </div>
                </div>
            </div>
            <bip-card :showForm="showForm"
                      :variant="selVersion"
                      :bip="bipProjectData"
                      :location="location"

                      :abp-base="abpBase"
                      :reg-abp-base="regAbpBase"
                      :spf-list="spfList"
                      :region-list="regionList"
                      :version-list="versionList"

                      :dataTypeList="dataTypeList"
                      :direction-list="directionList"
                      :gp-list="gpList"
                      :exp-types="expTypes"

                      :bip-cif-list="bipCifList"
                      :criteria-values="criteriaValues"
                      :bip-link-criterias="bipLinkCriterias"
                      :bip-link-types="bipLinkTypes"
                      :dict-unit="dictUnit">
            </bip-card>
        </div>

        <!--Модальные окна-->
        <c-budg-agr-modal ref="refAgrModal" :agrBtnLst="agrBtnLst" @agrClk="agrClick"></c-budg-agr-modal>
        <c-budg-agr-hist-modal ref="refHistModal"></c-budg-agr-hist-modal>
        <c-sign-log-modal ref="refSignLogModal" @updateSign="getBipSign"></c-sign-log-modal>
        <c-sign-status-modal ref="refSignStatusModal"></c-sign-status-modal>
        <modal-gip ref="refModalGip"></modal-gip>
        <loading :active="loading" is-full-screen spinner="bar-fade-scale" color="#6495ED"/>
    </div>
</template>

<script>
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import VueElementLoading from "vue-element-loading";
import i18nService from "@/services/i18n";
import CBudgetAgreementModal from "@/modules/budget-request/components/budget-sum-calc/budget-agreement-modal.vue";
import CBudgetAgreementHistModal from "@/modules/budget-request/components/budget-sum-calc/budget-agreement-hist-modal.vue";
import CBudgetSignLogModal from "@/modules/budget/components/budget-sign-log-modal.vue";
import CBudgetSignStatusModal from "@/modules/budget/components/budget-sign-status-modal.vue";
import ModalGip from "@/modules/budget/bip/modal-gip.vue";
import BipCard from "@/modules/budget/bip/bip-card.vue";
import {
    BipProjectDataClass,
    sortByField,
    makeToast,
    padLeadingZeros,
    findItem,
    checkAccess,
    filterVersion,
    defineBip,
    forInitiator,
    forRecipient,
    postData,
    versionByRegion,
    setCurVariant,
    nameLocale,
    loadEbkMap,
    doRowKey,
    itemNameLocale,
    getYearRanges,
    createStatus,
    initLogging,
    trMsg,
    doNum,
    repDatas,
    userUiid,
    MSG_SMS,
    MSG_BIP,
    MSG_FILTER,
    MSG_CDF,
    MSG_FIELD,
    MSG_CARD_SEC,
    DEFAULT_ARRAY,
    PROP_ARRAY, verLatestApproved
} from "./bip-types";
import {numeric} from "vuelidate/lib/validators";

export default {
    name: "bip-uebp",
    components: {
        loading: VueElementLoading,
        "c-budg-agr-modal": CBudgetAgreementModal,
        "c-budg-agr-hist-modal": CBudgetAgreementHistModal,
        'c-sign-log-modal': CBudgetSignLogModal,
        'c-sign-status-modal': CBudgetSignStatusModal,
        'modal-gip': ModalGip,
        BipCard
    },
    props: {
        location: { type: Object, default: () => {} },
        mode_level: { type: numeric, default: () => 0 },
        mode_opers: { type: Array, default: () => DEFAULT_ARRAY },

        regionBudgetList: { type: Array, default: () => DEFAULT_ARRAY },
        versionList: { type: Array, default: () => DEFAULT_ARRAY },
        detailFields: { type: Array, default: () => DEFAULT_ARRAY },
        levels: { type: Array, default: () => DEFAULT_ARRAY },
        regLevels: { type: Array, default: () => DEFAULT_ARRAY },
        regionList: { type: Array, default: () => DEFAULT_ARRAY },

        dataTypeList: { type: Array, default: () => DEFAULT_ARRAY },
        directionList: { type: Array, default: () => DEFAULT_ARRAY },
        objectList: { type: Array, default: () => DEFAULT_ARRAY },
        statusList: { type: Array, default: () => DEFAULT_ARRAY },
        gpList: { type: Array, default: () => DEFAULT_ARRAY },
        expTypes: { type: Array, default: () => DEFAULT_ARRAY },
        bipCifList: { type: Array, default: () => DEFAULT_ARRAY },
        criteriaValues: { type: Map, default: () => DEFAULT_MAP },
        bipLinkCriterias: { type: Array, default: () => DEFAULT_ARRAY },
        bipLinkTypes: { type: Array, default: () => DEFAULT_ARRAY },
        dictUnit: { type: Array, default: () => DEFAULT_ARRAY },
        gipList: PROP_ARRAY(false)
    },
    data() {
        return {
            MSG_BIP,
            MSG_FILTER,
            MSG_SMS,
            MSG_CDF,
            MSG_FIELD,
            MSG_CARD_SEC,

            mode: 'bip',
            mode_sign: 'mode',
            mode_code: '004.003.002',
            appNum: 68,

            ebkMap: new Map(),
            abpBase: [],
            regAbpBase: [],

            costsMap: null,
            agrMap: new Map(),
            signMap: new Map(),

            yearsFilter: getYearRanges(),

            planPeriod: null,
            selRegionBudget: null,
            selRegion: null, // текущий регион
            selKato: null, // текущий НП
            selDataType: null,
            selVersion: null,
            selGip: null,
            selDirection: null,
            selObject: null, // текущий тип объекта
            selStatus: null, // текущий статус
            selAbp: null,
            selPrg: null,
            selPpr: null,
            selGp: null,

            radio: null,
            spfList: [],

            agrBtnLst: { back: [], forward: [] },

            bipList: [],
            bipProjectData: null,
            sign: undefined,
            meta: {},
            open: false,
            check: false,
            showForm: false,
            openFilterWindow: false,
            loading: false,
            agree: false,
            pBar: 0,
            gipFilter: false
        };
    },

    created() {
        initLogging('uebp created');
    },

    mounted() {
        initLogging('uebp mounted');

        // Группировка связанных вотчеров
        this.setupReactiveTriggers([
            {
                prop: 'regionBudgetList',
                handler: (value) => {
                    if (value?.length) {
                        this.selRegionBudget = value[0];
                        versionByRegion(this);
                    }
                },
                immediate: true
            },
            {
                props: ['planPeriod', 'selRegionBudget'],
                handler: () => setCurVariant(this)
            },
            {
                props: ['selDataType'],
                handler: () => setCurVariant(this, true)
            },
            {
                prop: 'selVersion',
                handler: (value) => {

                    this.submitReports();

                    ['selRegion', 'selDirection', 'selObject', 'selStatus', 'selAbp', 'selGp']
                        .forEach(prop => this[prop] = null);
                    this.sign = undefined;
                    this.bipList = [];
                    this.selGip = [];
                    this.gipFilter = false;

                    if (value && !this.loading) {
                        initLogging('uebp selVersion', value);
                        this.loading = true;

                        this.getActSigns();
                        this.loadMetaDatas();
                        this.loadBipPackage();
                    }
                }
            },
            {
                prop: 'selAbp',
                handler: () => {
                    this.selPrg = null;
                    this.selPpr = null;
                    if (this.selAbp === null) {
                        this.sign = undefined;
                    }
                    this.getBipSign();
                }
            },
            {
                prop: 'check',
                handler: (value) => {
                    this.showBipList.forEach(row => {
                        if (checkAccess(row, "uebp_agree", "oebp_agree_recipient", this.selRegionBudget?.code)) {
                            row.check = value;
                        }
                    });
                }
            },
            {
                prop: 'agree',
                handler: (value) => value && this.autoRevokeSign()
            },
            {
                prop: 'showBipList',
                handler: (value) => value?.length && this.submitReports()
            }
        ]);
    },

    beforeUpdate() {
        this.showBipList?.forEach(row =>
            row && (row._rowVariant = row._showDetails ? 'info' : null)
        ) ?? [];
    },

    computed: {
        access() {
            return ([2, 3].includes(this.mode_level) && this.selVersion?.attribute);
        },

        gip_check() {
            const ver = verLatestApproved(this.versionList, this.selVersion.year, this.selVersion.region_code);
            return ([2].includes(this.mode_level) && (this.selVersion.attribute || ver !== null))
        },

        totalFinans() {
            return this.showBipList
                .flatMap(row => row.addDatas.finace)
                .reduce((sum, fin) => sum + fin.ppr_cost, 0);
        },

        regionFilter() {
            if (!this.showBipList?.length || !this.regionList?.length) return [];
            const codeSet = new Set(this.showBipList.map(item => item.region));
            return this.regionList.filter(row => codeSet.has(row.code));
        },

        versionFilter() {
            return filterVersion(this);
        }, // список для фильтра по версиям

        filterGip() {
            if (!this.showBipList?.length || !this.gipList?.length) return [];

            // Получаем массив выбранных кодов из selGip
            const selectedCodes = this.gipFilter ? this.selGip?.map(item => item.code) : [];

            // Если ничего не выбрано, показываем все доступные
            if (!selectedCodes.length) {
                const codeSet = new Set(this.showBipList.map(item => item.gipCode));
                return this.gipList.filter(row => codeSet.has(row.code));
            }

            // Фильтруем по выбранным кодам
            return this.gipList.filter(row => selectedCodes.includes(row.code));
        },

        directionFilter() {
            if (!this.showBipList?.length || !this.directionList?.length) return [];
            const codeSet = new Set(this.showBipList.map(item => Number(item.projectType)));
            return this.directionList.filter(row => codeSet.has(Number(row.code)));
        },

        objectFilter() {
            if (!this.showBipList?.length || !this.objectList?.length) return [];
            const codeSet = new Set(this.showBipList.map(item => Number(item.object)));
            return this.objectList.filter(row => codeSet.has(Number(row.code)));
        },

        statusFilter() {
            if (!this.showBipList?.length || !this.statusList?.length) return [];
            const codeSet = new Set(this.showBipList.map(item => item?.addDatas?.status?.code));
            return this.statusList.filter(row => codeSet.has(row.code));
        },

        abpFilter() {
            const codeSet = new Set(
                this.showBipList
                    .map(b => b.addDatas?.abp?.abp)
                    .filter(Boolean)
                    .map(Number)
            );

            return Array.from(this.ebkMap.values()).filter((row) => codeSet.has(Number(row.abp)));
        },

        gpFilter() {
            return this.gpList?.filter(item =>
                new Set(
                    this.showBipList?.flatMap(row =>
                        Array.isArray(row.governmentProgram)
                            ? row.governmentProgram.map(gp => gp.code)
                            : []
                    )
                ).has(item.code)
            ) || [];
        },

        prgFilter() {
            return this.selAbp?.value?.child?.filter(item => {
                const programCodes = new Set(
                    this.showBipList?.flatMap(row =>
                        row.addDatas?.finace?.map(f => Number(f.prg)) || []
                    )
                );
                return programCodes.has(Number(item.prg));
            }) || [];
        },

        pprFilter() {
            return this.selPrg?.value?.child?.filter(item => {
                // Собираем все ppr из объединенных массивов
                const pprCodes = new Set(
                    this.showBipList?.flatMap(bip => [
                        ...(bip.newFinace || []),
                        ...(bip.newFinaceRegional || [])
                    ]).map(fin => Number(fin?.ppr)).filter(Number.isInteger)
                );
                return pprCodes.has(Number(item?.ppr));
            }) || [];
        },

        showBipList() {
            // Вспомогательные функции
            const safeParse = val => Number(val ?? 0);
            const matchCode = (a, b) => safeParse(a) === safeParse(b);
            const hasProperty = (obj, prop) => Object.hasOwn(obj ?? {}, prop);
            // Вспомогательная функция для получения вложенных свойств
            const getNestedValue = (obj, path) =>
                path.split('.').reduce((acc, key) => acc?.[key], obj);

            // Базовый список
            let result = [...(this.bipList ?? [])];

            // Фильтр по версии
            if (this.selVersion?.variant_uuid) {
                const variantUUID = this.selVersion.variant_uuid;
                result = result.filter(row =>
                    row.variant === variantUUID ||
                    row.variant_recipient === variantUUID
                );
            }

            // Фильтр по ГИП
            if (this.gipFilter && this.selGip) {
                const selectedCodes = this.selGip?.map(item => item.code) || [];

                // Если ничего не выбрано, показываем все доступные
                if (selectedCodes.length) {
                    result = result.filter(row => selectedCodes.includes(row.gipCode));
                }
            }

            // Фильтр по радио-кнопке
            if (this.radio?.value !== undefined) {
                const filterNewProject = {
                    0: row => hasProperty(row, 'newProject') && row.newProject === 0,
                    1: row => !hasProperty(row, 'newProject') || row.newProject === 1
                }[this.radio.value];

                if (filterNewProject) {
                    result = result.filter(filterNewProject);
                }
            }

            // Фильтр по региону
            if (this.selRegion?.code) {
                result = result.filter(row => row?.region === this.selRegion.code);
            }

            // Фильтр по KATO (исправлена опечатка this.result -> result)
            if (this.selKato?.code) {
                result = result.filter(row =>
                    [row?.localityObject?.code, row?.locality].includes(this.selKato.code)
                );
            }

            // Общий фильтр для числовых полей
            const numberFilters = [
                { condition: this.selDirection, field: 'projectType' },
                { condition: this.selObject, field: 'object' },
                { condition: this.selStatus, field: 'addDatas.status.code' },
                { condition: this.selAbp, field: 'addDatas.abp.abp' }
            ];

            numberFilters.forEach(({ condition, field }) => {
                if (condition?.code !== undefined) {
                    result = result.filter(row =>
                        matchCode(getNestedValue(row, field), condition.code)
                    );
                }
            });

            // Фильтры по программам и госпрограммам
            const createIdFilter = (condition, path) => {
                if (!condition?.code) return;

                const ids = result.flatMap(item =>
                    getNestedValue(item, path)
                        ?.filter(f => matchCode(f?.code ?? f?.prg, condition.code))
                        ?.map(() => item.id) ?? []
                );

                result = result.filter(row => ids.includes(row.id));
            };

            createIdFilter(this.selPrg, 'addDatas.finace');
            createIdFilter(this.selGp, 'governmentProgram');

            return result;
        },

        tableFields() {
            return [
                {
                    key: "check",
                    label: " "
                },
                {
                    key: "gipCode",
                    label: trMsg(this, MSG_FIELD + 'gip_code'),
                    sortable: true
                },
                {
                    key: "code",
                    label: trMsg(this, MSG_FIELD + 'bip_code'),
                    sortable: true
                },
                {
                    key: "name",
                    label: trMsg(this, MSG_FIELD + 'project_name'),
                    sortable: true
                },
                {
                    key: "total",
                    label: trMsg(this, MSG_FIELD + 'grade') + ', ' + trMsg(this, MSG_FIELD + 'point'),
                    sortable: true
                },
                {
                    key: "totalCost",
                    label: trMsg(this, MSG_FIELD + 'cost_project')  + ', ' + trMsg(this, MSG_CARD_SEC + '1.thousand_tg'),
                    sortable: true
                },
                {
                    key: "status",
                    label: trMsg(this, MSG_FILTER + 'status')
                },
                {
                    label: trMsg(this, MSG_CDF + 'sign_status'),
                    key: 'sign_status',
                    sortable: true,
                    thClass: ((this.selAbp === null) ? 'd-none' : ''),
                    tdClass: ((this.selAbp === null) ? 'd-none' : '')
                },
                {
                    key: "abp",
                    label: trMsg(this, MSG_FILTER + 'ABP')
                },
                {
                    key: "prg",
                    label: trMsg(this, MSG_FIELD + 'prg')
                },
                {
                    key: "ppr",
                    label: trMsg(this, MSG_FIELD + 'ppr'),
                    variant: "warning"
                },
                {
                    key: "ppr_cost",
                    label: trMsg(this, MSG_FIELD + 'cost_by_ppr')  + ', ' + trMsg(this, MSG_CARD_SEC + '1.thousand_tg'),
                },
                {
                    key: "plan1",
                    label: "",
                    variant: "warning"
                },
                {
                    key: "plan2",
                    label: ""
                },
                {
                    key: "plan3",
                    label: "",
                    variant: "warning"
                },
                {
                    key: "more",
                    label: ""
                }
            ]
        }
    },

    methods: {

        // Общий метод для настройки наблюдателей
        setupReactiveTriggers(configs) {
            configs.forEach(({ prop, props, handler, immediate }) => {
                const callback = (value) => {
                    initLogging('uebp ' + prop, value);
                    handler(value);
                };

                if (props) {
                    this.$watch(() => props.map(p => this[p]), callback, { deep: true });
                } else {
                    this.$watch(prop, callback, { immediate });
                }
            });
        },

        async agreementEvent() {
            // Фильтрация выбранных элементов
            const selectedItems = this.showBipList.filter(row =>
                row.check && row.addDatas?.status
            );

            if (selectedItems.length === 0) {
                makeToast(this, 'warning', trMsg(this, MSG_SMS + 'coordination'),
                    trMsg(this, MSG_SMS + 'no_project_selected'));
                return;
            }

            // Проверка согласованности статусов и структуры
            const { firstStatus, firstHeader, validationError } = this.validateSelection(selectedItems);
            if (validationError) return;

            const nextSteps = await this.fetchNextSteps({
                modeCode: this.mode,
                operationCode: this.mode_opers.filter(item => item !== 'gu_edit' && !item.startsWith('ecp_sign')),
                agrCode: firstStatus
            });
            if (!nextSteps) return;

            if (nextSteps.length === 0) {
                makeToast(this, 'warning', trMsg(this, MSG_SMS + 'coordination'),
                    trMsg(this, MSG_SMS + 'no_approval_steps_available'));
                return;
            }

            // Инициализация состояния кнопок
            this.agrBtnLst = { back: [], forward: [] };
            this.agrBtnLst = this.processNextSteps(nextSteps);

            if (this.agrBtnLst.back.length === 0 && this.agrBtnLst.forward.length === 0) {
                makeToast(this, 'warning', trMsg(this, MSG_SMS + 'attention'),
                    trMsg(this, MSG_SMS + 'insufficient_rights_negotiate'));
                return;
            }

            this.$refs.refAgrModal.showEvent();
        },

        validateSelection(rows) {
            let firstStatus = 0;
            let firstHeader = false;

            for (const row of rows) {
                const status = row.addDatas?.status.code;
                const hasRegional = row.header?.hasOwnProperty('regional');

                if (firstStatus === 0) {
                    firstStatus = status;
                    firstHeader = hasRegional;
                }

                if (status !== firstStatus || hasRegional !== firstHeader) {
                    const messageKey = status !== firstStatus
                        ? 'sel_BIPs_with_identical_stat'
                        : 'sel_BIPs_only_with_or_without_recipient';

                    makeToast(this, 'danger', trMsg(this, MSG_SMS + 'coordination'),
                        trMsg(this, MSG_SMS + messageKey));
                    return { firstStatus: -1, firstHeader: false, validationError: true };
                }
            }

            // return { firstStatus, firstHeader, validationError: false };
            return {
                firstStatus: firstStatus ?? -1, // default value
                firstHeader: firstHeader ?? false,
                validationError: false
            };
        },

        async fetchNextSteps(params) {
            try {
                const response = await fetch(`/api-py/get-step-next-back/${encodeURI(JSON.stringify(params))}`);
                const data = await response.json();
                nameLocale(data);
                return data;
            } catch (error) {
                makeToast(this, 'danger',
                    trMsg(this, MSG_SMS + 'error_request'),
                    '/get-agreement-step-next-back ' + error.toString());
                return null;
            }
        },

        processNextSteps(nextSteps) {
            const back = []; // Явное указание типа
            const forward = []; // Явное указание типа

            nextSteps.forEach((el) => {
                const targetArray = el.stepType === 1 ? back : forward;

                targetArray.push(el);
            });

            return { back: back, forward: forward };
        },

        async agrClick(agree) {
            this.agree = false;
            const newAgree = [];
            const checkList = this.showBipList.filter(row => row.check && row.addDatas?.status);

            try {
                await this.processBipItems(checkList, newAgree, agree);
                await this.saveCosts(checkList);
                await this.handleAgreementSubmission(newAgree, agree);
            } catch (error) {
                makeToast(this, 'danger', trMsg(this, MSG_SMS + 'error_request'),
                    error.message);
            } finally {
                checkList.forEach(row => {
                    row.check = false;
                });
            }
        },

        async processBipItems(checkList, newAgree, agree) {
            const processItem = async (bip) => {
                if (bip.header?.finalAbp === 1) {
                    newAgree.push(createStatus(agree, bip, bip.header, this.selVersion));
                    return;
                }

                await this.processBudgetConditions(bip, newAgree, agree);
            };

            await Promise.all(checkList.map(processItem));
        },

        async processBudgetConditions(bip, newAgree, agree) {
            const isInitiator = this.selRegionBudget.code === bip.region_budget;
            const isRecipient = this.selRegionBudget.code === bip.district_budget;

            if (isInitiator) {
                await this.handleInitiator(bip, newAgree, agree);
            }

            if (isRecipient) {
                await this.handleRecipient(bip, newAgree, agree);
            }
        },

        async handleInitiator(bip, newAgree, agree) {
            const data = await forInitiator(this, 'uebp', bip, this.versionList);

            if (this.isValidResponse(data)) {
                const initiatorVersion = this.selVersion;
                const recipientVersion = data.versions_rec[0];

                newAgree.push(
                    createStatus(agree, bip, bip.header, initiatorVersion),
                    createStatus(agree, bip, bip.header.regional, recipientVersion)
                );

                await this.saveForm(bip,
                    initiatorVersion.variant_uuid,
                    recipientVersion.variant_uuid
                );
            }
        },

        async handleRecipient(bip, newAgree, agree) {
            const data = await forRecipient(this, 'uebp', bip, this.versionList);

            if (this.isValidResponse(data)) {
                const initiatorVersion = data.versions[0];
                const recipientVersion = this.selVersion;

                newAgree.push(
                    createStatus(agree, bip, bip.header, initiatorVersion),
                    createStatus(agree, bip, bip.header.regional, recipientVersion)
                );

                await this.saveForm(
                    bip,
                    initiatorVersion.variant_uuid,
                    recipientVersion.variant_uuid
                );
            }
        },

        isValidResponse(data) {
            return (data?.versions_rec?.length > 0 && data.findDB === 0) ||
                (data?.versions?.length > 0 && data.findDB === 0);
        },

        async handleAgreementSubmission(newAgree, agree) {
            if (newAgree.length === 0) return;

            const response = await postData('/api-py/set_bip_agreement_step', newAgree);
            this.processServerResponse(response, agree);
        },

        processServerResponse(response, agree) {
            const errorItems = response.filter(item => item.result === 'error');
            const successItems = response.filter(item => item.result !== 'error');

            errorItems.forEach(item => {
                makeToast(this, "danger", trMsg(this, MSG_SMS + 'error_save'),
                    error.toString());
            });

            successItems.forEach(item => {
                if (item.bip_denied) {
                    this.resetFinancialPlans(item?.code);
                }
                makeToast(this, "success", trMsg(this, MSG_SMS + 'saving'),
                    trMsg(this, MSG_SMS + 'success'));
            });

            if (agree.stepType === 1) {
                this.agree = true;
            }

            this.loadBipAgreement();
            this.getBipSign();
        },

        resetFinancialPlans(code) {
            const targetBip = this.showBipList.find(bip => bip.code === code);
            if (!targetBip) return;

            targetBip.addDatas.finace.forEach(fin => {
                ['plan1', 'plan2', 'plan3'].forEach(field => {
                    fin[field] = 0;
                });
            });
        },

        async autoRevokeSign() {
            const params = {
                source: 'uebp',
                variant: this.selVersion.variant_uuid,
                abp: this.selAbp.abp,
                comment: null,
                user_id: userUiid,
                auto: true
            };

            try {
                const response = await postData('/api-py/revoke-bip-data', params);

                if (response?.result === 'success' && response?.res > 0) {
                    makeToast(this, 'success',
                        trMsg(this, MSG_CDF + 'revoke_sign'),
                        trMsg(this, MSG_CDF + 'sign_revoked')
                    );
                    await this.getActSigns(); // Перенесено в блок успеха
                }
            } catch (error) {
                makeToast(this, 'danger',
                    trMsg(this, MSG_CDF + 'error'),
                    trMsg(this, MSG_CDF + 'request_failed') + ' /revoke-bip-data'
                );
            } finally {
                this.agree = false; // Сброс в любом случае
            }
        },

        async changeRegion() {
            if (!this.selRegion) return;

            const katoSet = new Set(this.showBipList
                .filter(row => row.hasOwnProperty("localityObject") && row.localityObject)
                .map(item => item.localityObject.code));

            this.selRegion.localityList = this.selRegion.localityList.filter((row) => katoSet.has(row.code));
            this.selKato = null;
        },

        checkAccess(bip) {
            return checkAccess(
                bip,
                "uebp_agree",
                "oebp_agree_recipient",
                this.selRegionBudget.code,
            );
        },

        emitAppDatas(num) {
            // 1. Быстрый эмит с appNum для отображения в интерфейсе родителя
            this.$emit("repApp", { appNum: num });

            // 2. Проверка обязательных параметров
            if (!this.selAbp || !this.selPrg) {
                // Эмит уже был, просто выходим
                return;
            }

            const { selVersion, planPeriod, selDataType, selAbp, selPrg, selPpr } = this;

            // 3. Получение GU и количества финансовых записей
            const { gu, totalEntries } = this.getGuAndTotalEntries(selVersion, selAbp);

            // Валидация наличия данных
            if (totalEntries === 0) {
                makeToast(this, 'danger',
                    trMsg(this, MSG_BIP + 'app') + ' ' + num,
                    trMsg(this, MSG_SMS + 'information_financing_plan_period_not_filled'));
                return;
            }

            // Подготовка локализованных полей
            const locale = i18nService.locale;
            const localizedField = (field) => `${field}_${locale}`;

            // Формирование базовых параметров
            const baseParams = {
                appNum: num,
                year: planPeriod.year,
                data_type: selDataType[localizedField('name')],
                variant_uuid: selVersion.variant_uuid,
                abp: selAbp.abp,
                prg: selPrg.prg,
                ppr: selPpr?.ppr ?? 0,
                lang: locale,
                version_name: selVersion[localizedField('name')],
                abp_name: selAbp.value?.[localizedField('name')] ?? '',
                prg_name: selPrg.value?.[localizedField('name')] ?? '',
                sign_code: []
            };

            // 4. Получение подписей (безопасно)
            let sortedSignCodes = [];
            try {
                if (this.sign?.signers && Array.isArray(this.sign.signers)) {
                    sortedSignCodes = [...this.sign.signers].sort(sortByField("order_num"));
                }

            } catch (error) {
                console.error('[repApp] Error processing signers:', error);
            }
            this.$emit("repApp", {
                ...baseParams,
                sign_code: sortedSignCodes
            });
        },

        emitUebpVersion() {
            if (!this.selVersion) return;

            this.$emit("uebpVersion", this.selVersion);
        },

        emitBipRegion() {
            this.emitUebpVersion();
            this.$emit("bipRegion", {
                region: this.selRegionBudget,
                dtype: this.selDataType,
                abp: this.selAbp,
                prg: this.selPrg,
                ppr: this.selPpr
            });
        },

        commentClk(agrObj) {
            if (!agrObj) return;

            // Устанавливаем mode только если значение изменилось
            if (agrObj.mode !== this.mode) {
                this.$set(agrObj, 'mode', this.mode);
            }

            // Безопасный вызов метода, если ref существует
            this.$refs.refHistModal?.showEvent(agrObj);
        },

        defineBipList(serverList) {
            if (!serverList?.length) return;

            const startTime = performance.now();
            this.loading = true;
            this.pBar = 0;
            const step = 100 / serverList.length;

            try {
                serverList.forEach((bip, index) => {
                    const bipObject = BipProjectDataClass.fromJSON(bip);
                    if (!bipObject?.isDeleted && ![35, 36, 37, 38].includes(parseInt(bipObject.object))) {
                        defineBip(this, bipObject, 'uebp');

                        // sign status
                        const sign = this.signMap.get(doRowKey([bipObject.header.abp, bipObject.variant]));
                        this.$set(bipObject, 'sign', (sign ? sign.length > 0 : false));
                        if (bipObject.header.finalAbp === 0) {
                            const sign_rec = this.signMap.get(doRowKey([bipObject.header.regional.abp, bipObject.variant_recipient]));
                            this.$set(bipObject, 'sign', bipObject.sign || (sign_rec ? sign_rec.length > 0 : false));
                        }

                        this.bipList.push(bipObject);
                    }

                    // Более предсказуемое обновление прогресса
                    this.pBar = Math.min(100, Math.round((index + 1) * step));
                });

                // Сохраняем только последний элемент при необходимости
                this.bipProjectData = this.bipList.length > 0 ? this.bipList[this.bipList.length - 1] : null;
            } catch (error) {
                console.error('DefineBipList error:', error);
                throw new Error(`Bip processing failed: ${error instanceof Error ? error.message : error}`);
            } finally {
                initLogging(`uebpList: ${(performance.now() - startTime).toFixed(2)}ms`, this.bipList);
                this.loading = false;
                this.pBar = 100;
            }
        },

        findItem(code, field, list) {
            return findItem(code, field, list);
        },

        async getActSigns() {
            if (!this.selVersion?.variant_uuid) return;

            try {
                const response = await fetch(`/api-py/get-active-signs/${this.selVersion.variant_uuid}`);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const data = await response.json();
                if (data?.signForm && typeof data.signForm === 'object') {
                    this.signMap = new Map(Object.entries(data.signUebp));

                    this.showBipList.forEach(bipObject => {
                        const sign = this.signMap.get(
                            doRowKey([bipObject.header.abp, bipObject.variant])
                        );
                        this.$set(bipObject, 'sign', (sign ? sign.length > 0 : false));
                        if (bipObject.header.finalAbp === 0) {
                            const sign_rec = this.signMap.get(
                                doRowKey([bipObject.header.regional.abp, bipObject.variant_recipient])
                            );
                            this.$set(bipObject, 'sign', bipObject.sign || (sign_rec ? sign_rec.length > 0 : false));
                        }
                    });
                } else {
                    throw new Error('Invalid response format: missing signForm');
                }
            } catch (error) {
                makeToast(this, 'danger',
                    trMsg(this, MSG_SMS + 'error_request'),
                    '/get-active-signs ' + error.toString());
            }
        },

        async getBipSign() {
            if (!userUiid || this.selAbp === null) return;

            try {
                this.loading = true;

                // 1. Подготовка данных
                const { variants, abps, plans } = this.processBipData();
                const params = {
                    variant: this.selVersion.variant_uuid,
                    region: this.selVersion.region_code,
                    abp: this.selAbp.abp,
                    mode: 'uebp',
                    mode_code: this.mode_code,
                    user_id: userUiid,
                    recParams: {
                        source: 'form',
                        variant: Array.from(variants),
                        abp: Array.from(abps)
                    }
                };

                // 2. Запрос данных
                const response = await postData('/api-py/get-bip-sign', params);
                response.signers = (response.signers || []).filter(row => row.id_user?.length > 0);
                response.mapRecSigns = new Map(Object.entries(response.mapRecSigns || {}));
                response.logMap = new Map(Object.entries(response.logMap || {}));

                const userLog = ((userUiid && response.logMap) ? (response.logMap.get(userUiid) ? response.logMap.get(userUiid) : []) : []);

                // является ли тек.пользователь одним из подписантов
                const present = response.signers.filter((row) => row.id_user === userUiid);

                const sign = this.selVersion.attribute // версия актуальна
                    && (this.selAbp!== null) // АБП определен
                    && (present.length > 0) // пользователь входит в перечень подписантов
                    && (response.gu && response.gu.some(row => response.wpList.includes(row.code))) // присутсвие ГУ в user_workplace_link
                    && (userLog.length === 0 || userLog.filter((row) => !row.deleted).length === 0) // По текущему пользователю отсутствуют активные подписания
                    && (response.form.logList.length > 0 && response.form.logList.filter((row) => !row.deleted).length > 0) // Присутствуют ли активные подписания в Реестре

                // проверка для двухуровневых БИП перед подписанием ролью "АБП (ур. получателя)"
                let recSign = true;
                for (const item of this.showBipList.filter((row) => row.header.finalAbp === 0)) {
                    const rec_sign = response['mapRecSigns'].get(doRowKey([item.header.abp, item.variant]))

                    if (rec_sign && Array.isArray(rec_sign)) {
                        if (rec_sign.length > 0 && rec_sign.filter((row) => !row.deleted).length === 0) {
                            recSign = recSign && true;
                        } else {
                            recSign = recSign && false;
                        }
                    } else {
                        recSign = recSign && true;
                    }
                }

                // право на отзыв (если имеется активная подпись)
                const recall = this.selVersion.attribute // версия актуальна
                    && (this.selAbp!== null) // АБП определен
                    && (present.length > 0) // пользователь входит в перечень подписантов
                    && (response.gu && response.gu.some(row => response.wpList.includes(row.code))) // присутсвие ГУ в user_workplace_link
                    && (userLog.filter((row) => !row.deleted).length > 0) // По текущему пользователю имеется активная подпись

                this.$set(response, 'sign', sign);
                this.$set(response, 'agree', false);
                this.$set(response, 'recall', recall);
                this.$set(response, 'status', 0);

                let status = 0;
                for (const row of response.signers) {
                    this.$set(row, 'log', response.logMap.get(row.id_user)); // лог подписанта

                    if (row.log && (row.log.length > 0)) {
                        const sign = row.log.filter((el) => !el.deleted);
                        if (sign.length > 0) {
                            status++;
                        }
                        if (row.id_user === userUiid) {
                            if (sign.length > 0) {
                                this.$set(response, 'ownerSign', true);
                            } else {
                                this.$set(response, 'ownerSign', false);
                            }
                        }
                    }
                }

                if (response.signers.length > 0 && status === response.signers.length) {
                    this.$set(response, 'status', 1);
                }
                if (response.signers.length > 0 && status > 0 && status < response.signers.length) {
                    this.$set(response, 'status', 2);
                }

                nameLocale(response.signers, 'code', 'sign_');
                nameLocale(response.signers);
                nameLocale(response.form.signers, 'code', 'sign_');
                nameLocale(response.form.signers);

                let i = 0; let k = 0;
                const listStat = []
                for (const item of this.showBipList.filter((row) => row.addDatas.status)) {
                    if (!item.addDatas.status) {
                        const stat = {
                            code: 1,
                            name_ru: 'Заявка (Проект)',
                            name_kk: 'Өтінім (Жоба)',
                            name_en: 'Application (Project)',
                            operations: [],
                            comment: ''
                        }
                        this.$set(item.addDatas, 'status', stat);
                    }
                    listStat.push(item);
                }
                for (const row of listStat) {
                    i++;
                    if (row.header.finalAbp === 1) {
                        if (this.selRegionBudget.code === row.region_budget
                            && this.meta.userGu.includes(row.header?.gu?.code)) {
                            if ([51, 52].includes(row.addDatas.status.code)
                                && (row.addDatas.status.operation_code !== null)
                                && row.addDatas.status.operation_code.includes('ecp_sign_uebp')) {
                                k++;
                            }
                        }
                    }
                    if (row.header.finalAbp === 0) {
                        if (this.selRegionBudget.code === row.region_budget
                            && this.meta.userGu.includes(row.header?.gu?.code)) {
                            // console.log('сижу под Инициатором')
                            if ([47, 48].includes(row.addDatas.status.code)
                                && (row.addDatas.status.operation_code !== null)
                                && row.addDatas.status.operation_code.includes('ecp_sign_uebp')) {
                                k++;
                            }
                        } else {
                            if (this.selRegionBudget.code === row.district_budget
                                && this.meta.userGu.includes(row.header?.regional?.gu?.code)) {
                                // console.log('сижу под Получателем')
                                if ([42, 45, 46, 47, 48].includes(row.addDatas.status.code)
                                    && (row.addDatas.status.operation_code !== null)
                                    && row.addDatas.status.operation_code.includes('ecp_sign_oebp')) {
                                    k++;
                                }
                            }
                        }
                    }
                }
                if ((k > 0) && (i === k)) {
                    this.$set(response, 'agree', true);
                }

                let val1 = 0; let val2 = 0; let val3 = 0;
                for (const bip of this.showBipList) {
                    for (const fin of bip.addDatas['finace']) {
                        val1 += fin['plan1'];
                        val2 += fin['plan2'];
                        val3 += fin['plan3'];
                    }
                }
                this.$set(response, 'plan1', val1);
                this.$set(response, 'plan2', val2);
                this.$set(response, 'plan3', val3);

                this.sign = response;

            } catch (error) {
                makeToast(this, 'danger', trMsg(this, MSG_SMS + 'error_load'),
                    '/get-bip-sign' + error.toString());
            } finally {
                this.loading = false;
                initLogging('uebp sign', this.sign);
            }
        },

        processBipData() {
            return this.showBipList.reduce((acc, bip) => {
                // Сбор вариантов и ABP
                if (bip.header?.finalAbp === 0 && bip.variant) {
                    acc.variants.add(bip.variant);
                    acc.abps.add(bip.header.abp);
                }

                // Расчет планов
                const finances = bip.addDatas?.finace || [];
                finances.forEach(fin => {
                    acc.plans.plan1 += fin.plan1 || 0;
                    acc.plans.plan2 += fin.plan2 || 0;
                    acc.plans.plan3 += fin.plan3 || 0;
                });

                return acc;
            }, {
                variants: new Set(),
                abps: new Set(),
                plans: { plan1: 0, plan2: 0, plan3: 0 }
            });
        },

        inputFixed(elem, item, field, value, digit = 1) {
            item[field] = doNum(value); // Для Vue 3 используем реактивность по умолчанию
            this.$set(elem.addDatas, 'edited', true);
        }, // форматирует введенное значение до digit цифр после запятой

        isNextStep(bip) {
            return bip?.addDatas?.status?.steps?.some(
                step => step.step_type === 2
            ) ?? false;
        },

        keyPress: function (event, pattern) {
            // const regex = new RegExp('^[0-9]+$');
            // const regex = new RegExp('^-?\\d*\\d{0,9}$');
            // const regex = new RegExp('^-?\\d*\\.?\\d{0,9}$');
            // const regex = new RegExp(pattern);
            // const key = String.fromCharCode(
            //     !event.charCode ? event.which : event.charCode,
            // );
            const key = event.key;
            const regex = new RegExp(pattern);

            if (!regex.test(key)) {
                event.preventDefault();
                return false;
            }
            return true;
        }, // вводит по заданному паттерну

        keyup13: function (event) {
            if (event.key !== 'Enter') return;

            event.preventDefault();
            const inputs = Array.from(document.querySelectorAll('input:not([disabled])'));
            const currentIndex = inputs.findIndex(input => input === event.target);

            if (currentIndex === -1) return;

            const nextIndex = (currentIndex + 1) % inputs.length;
            inputs[nextIndex]?.focus();
            inputs[nextIndex]?.select();
        }, // enter работает как tab

        async loadBipAgreement(code = '') {
            const params = {
                mode: this.mode,
                mode_code: this.mode_code,
                operation_code: this.mode_opers,
                variant: this.selVersion.variant_uuid,
                // Добавляем code, если он должен использоваться
                ...(code && { code }) // если параметр code нужен в запросе
            };

            try {
                const response = await postData('/api-py/get-bip-agreement-by-params', params);

                // Сразу создаем Map (проверка response не нужна, так как при ошибке будет исключение)
                const agrMap = new Map(Object.entries(response));

                // Обрабатываем элементы (предполагая, что itemNameLocale синхронная)
                for (const agr of agrMap.values()) {
                    itemNameLocale(agr);
                }

                // Оптимизируем обновление bipList
                this.bipList.forEach(bip => {
                    this.$set(bip.addDatas, 'status', agrMap.get(bip.code));
                });

                // Сохраняем agrMap если нужно использовать позже
                this.agrMap = agrMap;

            } catch (error) {
                makeToast(this, 'danger',
                    trMsg(this, MSG_SMS + 'attention'),
                    `${trMsg(this, MSG_SMS + 'error_request')} /get-bip-agreement-by-params`
                );
                // Добавляем логирование ошибки
                console.error('Error loading BIP agreement:', error);
            }
        },

        /**
         * открыть Журнал
         */
        async logEDS(mode) {
            if (!this.sign) {
                return;
            }
            const params = {
                mode: 'uebp',
                mode_sign: mode,
                version: this.selVersion,
                abp: this.selAbp,
                userGuList: this.meta['userGu'],
                userUiid,
                val1: this.sign.val1,
                val2: this.sign.val2,
                val3: this.sign.val3
            };

            this.$refs.refSignLogModal.showEvent(this.sign, params);
            this.mode_sign = 'mode';
        },

        async loadMetaDatas() {
            this.appNum = await repDatas('bip.app', this.planPeriod.year);

            try {
                this.meta = await fetch('/api-py/get-user-meta/' + userUiid + '/' + this.selRegionBudget.code)
                    .then((response) => response.json());
            } catch (error) {
                makeToast(this, 'danger', trMsg(this, MSG_SMS + 'error_request'),
                    '/get-user-meta' + error.toString());
            } finally {
                initLogging('uebp userMeta', this.meta);
            }
        },

        async loadBipPackage() {
            try {
                const params = {
                    mode: this.mode,
                    mode_code: this.mode_code,
                    operation_code: this.mode_opers,
                    variant: this.selVersion.variant_uuid
                };

                const response = await postData('/api-py/bip-package', params);
                this.pBar = 10;

                // Инициализация maps
                const mapEntries = (obj) => new Map(Object.entries(obj));
                this.ebkMap = mapEntries(response.abpMap);
                this.agrMap = mapEntries(response.agrMap);
                this.costsMap = mapEntries(response.costsMap);
                this.signMap = mapEntries(response.signUebp);

                // Обработка списков
                this.spfList = response.spfList
                    ?.filter((row) => row.type === 4)
                    .sort(sortByField('spf')) || [];
                nameLocale(this.spfList, 'spf');

                await loadEbkMap(this, 'uebp');

                // Обработка основного списка
                if (response.bipList?.length && this.ebkMap.size) {
                    this.pBar = 45;
                    await new Promise(resolve => setTimeout(resolve, 3000));
                    this.defineBipList(response.bipList);
                } else {
                    makeToast(this, 'warning',
                        trMsg(this, MSG_SMS + 'attention'),
                        trMsg(this, MSG_SMS + 'no_datas_by_version'))
                    this.pBar = 100;
                    this.loading = false;
                }
            } catch (error) {
                makeToast(this, 'danger',
                    trMsg(this, MSG_SMS + 'error_request'),
                    '/bip-package ' + error.toString());
            }
        },

        modalGip() {
            const gipCodes = [...new Set(
                this.showBipList
                    .filter(row => row.gipCode && row.check)
                    .map(row => row.gipCode)
            )];

            if (gipCodes.length > 0) {
                this.$refs.refModalGip.showEvent(gipCodes, this.selVersion.year, this.location);
            }
        },

        // Вынесение логики создания стоимости в отдельный метод
        createCost(
            fin,
            value,
            yearOffset,
            row
        ) {
            return {
                gr: fin.gr,
                pgr: fin.pgr,
                abp: fin.abp,
                prg: fin.prg,
                ppr: fin.ppr,
                spf: fin.spf,
                value,
                year: this.selVersion.year + yearOffset,
                region: row.addDatas?.region,
                bip_code: row.code,
                cur_year: this.selVersion.year,
                data_type: this.selVersion.data_type,
                variant: this.selVersion.variant_uuid,
                user_name: userUiid
            };
        }, // формирует элемент для сохранение в БД

        openBip(item) {
            this.bipProjectData = BipProjectDataClass.assign(item);

            // Использование requestAnimationFrame вместо setTimeout для синхронизации с рендером
            requestAnimationFrame(() => {
                this.showForm = true;
            });
        },

        openFilterByRef(refName) {
            const drop = this.$refs.drop;
            drop.show(true);
            const refItem = this.$refs[refName];
            setTimeout(() => refItem.$el.focus(), 100);
        },

        openSign() {
            if (!this.sign || !this.sign?.signers) return;
            this.$refs.refSignStatusModal.showEvent(this.sign.signers);
        },

        padLeadingZeros(num, size) {
            return padLeadingZeros(num, size);
        }, // добавляет 0-ли перед num до size-значного размера

        async reduction(bipList) {
            const processItem = async (bip) => {
                if (bip.header?.finalAbp !== 0) return;

                const { code } = this.selRegionBudget;
                const isInitiator = code === bip.region_budget;
                const isRecipient = code === bip.district_budget;

                const handleResponse = (data, isInitiator) => {
                    const versions = isInitiator ? data.versions_rec : data.versions;
                    const targetUuid = isInitiator ?
                        this.selVersion.variant_uuid :
                        data.versions?.[0]?.variant_uuid;
                    const sourceUuid = isInitiator ?
                        data.versions_rec?.[0]?.variant_uuid :
                        this.selVersion.variant_uuid;

                    if (versions?.length && data.findDB === 0) {
                        this.saveForm(bip, sourceUuid, targetUuid);
                    }
                };

                if (isInitiator) {
                    const data = await forInitiator(this, 'uebp', bip, this.versionList);
                    handleResponse(data, true);
                }

                if (isRecipient) {
                    const data = await forRecipient(this, 'uebp', bip, this.versionList);
                    handleResponse(data, false);
                }
            };

            await Promise.all(bipList.map(processItem));
        },

        async saveCosts(list) {
            try {
                const costs = list.flatMap(row =>
                    (row.addDatas?.finace || []).flatMap(fin =>
                        [0, 1, 2].map(offset =>
                            this.createCost(fin, fin[`plan${offset + 1}`], offset, row)
                        )
                    )
                );

                if (costs.length) await this.saveVariant(costs);
            } catch (error) {
                console.error('Ошибка сохранения:', error);
                throw new Error('Не удалось сохранить данные');
            }
        }, // list for saving

        async saveForm(form, versions, versions_rec) {
            try {
                // Обновляем данные формы
                form = {
                    ...form,
                    variant: versions,
                    variant_recipient: versions_rec,
                    versions: [
                        ...(form.versions || []), // Инициализируем массив при необходимости
                        versions,
                        versions_rec
                    ]
                };

                // Формируем параметры запроса
                const params = {
                    variant: this.selVersion.variant_uuid,
                    mode: this.mode,
                    mode_code: this.mode_code,
                    operation_code: this.mode_opers
                };

                // Отправляем данные на сервер
                const { result, error } = await postData("/api-py/save-bip-form", {
                    form,
                    variant: versions,
                    variant_recipient: versions_rec,
                    user_name: userUiid,
                    params
                });

                // Обрабатываем результат
                if (!result) {
                    throw new Error(`${form.code} => ${error}`);
                }

                // Уведомление об успехе (раскомментировать при необходимости)
                // makeToast(this, "success", trMsg(this, MSG_SMS + 'saved'), `${form.code} сохранен`);

            } catch (error) {
                makeToast(this, "danger", trMsg(this, MSG_SMS + 'error_save'),
                    form.code + " => " + error.toString());
                throw error; // Пробрасываем ошибку для внешней обработки
            }
        },

        async saveVariant(items) {
            if (!items?.length) {
                return false;
            }

            try {
                const { result } = await postData("/api-py/save-cost-budget-data/", items);

                const messageKey = result === 'success'
                    ? trMsg(this, MSG_SMS + 'datas_saved')
                    : trMsg(this, MSG_SMS + 'error_save');

                makeToast(this, result === 'success' ? 'success' : 'danger',
                    trMsg(this, MSG_SMS + 'message'), messageKey);

                return result === 'success';

            } catch (error) {
                makeToast(this, "danger", trMsg(this, MSG_SMS + 'warning'),
                    trMsg(this, MSG_SMS + 'error_save'));
            }
        }, // сохранение записей в БД

        submitReports() {
            this.submitReport();
            this.emitAppDatas(this.appNum);
            this.emitUebpVersion();
            this.emitUebpVersion();
        },

        // Вынесенная функция трансформации одного BIP
        transformBipToReportItem(bip, statusList) {
            // Константы для конфигурации
            const DEBUG_CODE = '0'; // Вынести в конфиг при необходимости
            const DEFAULT_STATUS_TYPE = 1;

            const {
                code,
                name,
                total = 0,
                totalCost = 0,
                addDatas = {}
            } = bip;

            const {
                reg_loc,
                exp_type,
                type_obj,
                program = "",
                status,
                abp = {},
                finace = []
            } = addDatas;

            // Вычисляем финансовый список один раз
            const finList = this.setFinList(finace);

            // Отладочный вывод (только в разработке)
            if (process.env.NODE_ENV === 'development' && code === DEBUG_CODE) {
                console.debug('Отладочная информация по BIP:', { finace, finList });
            }

            // Получение статуса
            const statusName = status?.name ||
                findItem(DEFAULT_STATUS_TYPE, "code", statusList)?.name ||
                "";

            return {
                code,
                reg_loc,
                name,
                exp_type,
                type_obj,
                program,
                total,
                totalCost,
                statusItem: statusName,
                abp: abp.abp || "",
                dataList: finList
            };
        },

        submitReport() {
            // Деструктуризация часто используемых свойств
          const {
                planPeriod,
                selRegionBudget,
                selDataType,
                selVersion,
                selRegion,
                selDirection: selProject,
                selObject,
                selStatus,
                selAbp,
                selPrg,
                selPpr,
                selGp,
                radio,
                statusList
            } = this;

            /*

                       // Формирование списка данных
                       const dataList = this.showBipList.map(bip => {
                           // Деструктуризация и безопасный доступ к данным
                           const {
                               code,
                               name,
                               total = 0,
                               totalCost = 0,
                               addDatas = {}
                           } = bip;

                           const {
                               reg_loc,
                               exp_type,
                               type_obj,
                               program = "",
                               status,
                               abp = {},
                               finace = []
                           } = addDatas;

                           // Отладочное логирование
                           if (code === DEBUG_CODE) {
                               console.debug('Отладочная информация по BIP:', {
                                   finace: addDatas.finace,
                                   finList: this.setFinList(finace)
                               });
                           }

                           // Получение статуса
                           const getStatusName = () => {
                               return status?.name ||
                                   findItem(DEFAULT_STATUS_TYPE, "code", statusList)?.name ||
                                   "";
                           };

                           return {
                               code,
                               reg_loc,
                               name,
                               exp_type,
                               type_obj,
                               program,
                               total,
                               totalCost,
                               statusItem: getStatusName(),
                               abp: abp.abp || "",
                               dataList: this.setFinList(finace)
                           };
                       });*/


            // Проверка наличия обязательных данных (опционально, но повышает надёжность)
            if (!this.showBipList?.length) {
                // Можно просто эмитить пустой datas или ничего не делать
                console.warn('[submitReport] showBipList is empty');
            }

            // Формируем dataList, используя вынесенную функцию
            const dataList = this.showBipList.map(bip =>
                this.transformBipToReportItem(bip, this.statusList)
            );

            // Формирование параметров отчета
            const reportParams = {
                lang: i18nService.locale,
                planPeriod,
                year: planPeriod.year,
                selRegionBudget,
                selDataType,
                selVersion,
                selRegion,
                selProject,
                selObject,
                selStatus,
                selAbp,
                selPrg: selPrg ?? null,
                selPpr,
                selGp,
                radio,
                datas: dataList
            };

            this.$emit("submitReport", reportParams);
        },

        setFinList(finance) {
            // Получаем числовые значения для фильтрации
            const selectedPrg = Number(this.selPrg?.prg);
            const selectedPpr = Number(this.selPpr?.ppr);

            return finance.filter(fin => {
                // Фильтрация по выбранным значениям
                if (this.selPrg && fin.prg !== selectedPrg) return false;
                if (this.selPpr && fin.ppr !== selectedPpr) return false;
                return true;
            }).map(fin => {
                // Форматирование полей
                const formattedFields = ['prg', 'ppr', 'spf'].reduce((acc, field) => {
                    acc[field] = padLeadingZeros(fin[field], 3);
                    return acc;
                }, {});

                // Копирование остальных полей
                const otherFields = ['ppr_cost', 'fact1', 'fact2', 'fact3', 'plan1', 'plan2', 'plan3']
                    .reduce((acc, field) => {
                        acc[field] = fin[field];
                        return acc;
                    }, {});

                return { ...formattedFields, ...otherFields };
            });
        },

        getGuAndTotalEntries(selVersion, selAbp) {
            if (!this.showBipList?.length) return { gu: null, totalEntries: 0 };
            return this.showBipList.reduce((acc, bip) => {
                const isMainVariant = bip.variant === selVersion.variant_uuid;
                const isRecipientVariant = bip.variant_recipient === selVersion.variant_uuid;

                if (isMainVariant && bip.header?.abp === selAbp.abp) {
                    acc.gu = bip.header.gu;
                    acc.totalEntries += bip.newFinace?.length || 0;
                }
                if (isRecipientVariant && bip.header?.regional?.abp === selAbp.abp) {
                    acc.gu = bip.header.regional.gu;
                    acc.totalEntries += bip.newFinaceRegional?.length || 0;
                }
                return acc;
            }, { gu: null, totalEntries: 0 });
        },

        total(field, useAddData = false) {
            return this.showBipList?.reduce((sum, row) => {
                const value = useAddData
                    ? row.addDatas?.[field]
                    : row[field];

                const numericValue = Number(value) || 0;
                return sum + numericValue;
            }, 0) ?? 0;
        },

        _totalFinans(field) {
            return this.showBipList?.reduce((total, row) => {
                const finances = row.addDatas?.finace;
                if (!finances) return total;

                return total + finances.reduce((sum, fin) => {
                    const value = Number(fin[field] ?? 0);
                    return Number.isFinite(value) ? sum + value : sum;
                }, 0);
            }, 0) || 0;
        }, // итого по заданному полю

        // translate messages
        trMsg(field) {
            return trMsg(this, field);
        }
    }
};
</script>
